// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"094fa9fc","109":"094fa9fc","206":"66fe5362","350":"95ec0eb6","555":"19185013","583":"79bcef38","584":"19185013","599":"19185013","651":"19185013","672":"559d545a","859":"19185013"}[chunkId] + ".chunk.css";
};